export class ContentItemType implements IContentItemType {
  id?: string | undefined;
  title?: string | undefined;
  folder?: string | undefined;

  constructor(data?: IContentItemType) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.title = _data['title'];
      this.folder = _data['folder'];
    }
  }

  static fromJS(data: any): ContentItemType {
    data = typeof data === 'object' ? data : {};
    const result = new ContentItemType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['folder'] = this.folder;
    return data;
  }
}

export interface IContentItemType {
  id?: string | undefined;
  title?: string | undefined;
  folder?: string | undefined;
}